import cx from 'classnames';

import * as styles from './BottomToolbar.module.scss';

interface IconProps {
  ratio?: number;
  [key: string]: unknown;
}

type ToolSettings = {
  label: string;
  icon: (props: IconProps) => React.ReactNode;
  action: () => void;
};

interface BottomToolbarProps {
  sticky?: boolean;
  children?: React.ReactNode;
  tools?: ToolSettings[];
}

export function BottomToolbar({sticky = false, tools, children}: BottomToolbarProps) {
  const className = cx(styles.bottomToolbarWrapper, {[styles.bottomSticky]: sticky});

  if (children) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div className={className}>
      {tools?.map(({label, icon: Icon, action}) => (
        /** biome-ignore lint/a11y/useButtonType: existing linting error */
        <button
          data-qa-id={`bottom-sticky-toolbar-${label}`}
          className={styles.toolbarItem}
          key={label}
          onClick={action}
        >
          <Icon ratio={0.75} />
          <span className={styles.toolbarText}>{label}</span>
        </button>
      ))}
    </div>
  );
}
